<template>
    <submenu-page
        eyebrow="SCHOOL SERVICES"
        title="Subscription"
        description="Review portal and SMS subscription plans, balances and details."
        count-label="subscription options"
    >
        <Submenu />
    </submenu-page>
</template>
<script>


import Submenu from './Submenu.vue';
export default {
  components: {
    Submenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  }
};
</script>
<style></style>
